var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mx-auto error",on:{"click":_vm.resetData}},[_vm._v(" Reset data "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("mdi-restore")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }